import React, { useState } from 'react';
import { contactService } from '../services';
import PageBreadcrumb from '../components/PageBreadcrumb';

const Contact = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: '',
    });
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await contactService.submit(formData);
            setSubmitted(true);
            setFormData({
                name: '',
                email: '',
                phone: '',
                subject: '',
                message: '',
            });
            setTimeout(() => setSubmitted(false), 5000);
        } catch (error) {
            console.error('Error submitting form:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="bg-gray-50">
            <PageBreadcrumb
                title="Contact Us"
                description="Get in touch with our team for support, partnership, and collaboration."
                items={[{ label: 'Contact' }]}
            />
            {/* Contact Section */}
            <section className="py-16">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
                        {/* Contact Information */}
                        <div>
                            <h2 className="text-2xl font-bold text-gray-800 mb-6">Get In Touch</h2>
                            <div className="space-y-6">
                                <div>
                                    <h3 className="font-semibold text-gray-800 mb-2">Address</h3>
                                    <p className="text-gray-600">Islamabad, Pakistan</p>
                                </div>
                                <div>
                                    <h3 className="font-semibold text-gray-800 mb-2">Phone</h3>
                                    <p className="text-gray-600">+92 300 1234567</p>
                                </div>
                                <div>
                                    <h3 className="font-semibold text-gray-800 mb-2">Email</h3>
                                    <p className="text-gray-600">info@yapngo.pk</p>
                                </div>
                                <div>
                                    <h3 className="font-semibold text-gray-800 mb-2">Office Hours</h3>
                                    <p className="text-gray-600">Monday - Friday: 9:00 AM - 5:00 PM</p>
                                    <p className="text-gray-600">Saturday: 10:00 AM - 2:00 PM</p>
                                </div>
                            </div>

                            {/* Map */}
                            <div className="mt-8 rounded-lg overflow-hidden shadow-lg">
                                <iframe
                                    width="100%"
                                    height="300"
                                    frameBorder="0"
                                    title="YAP Location"
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3318.7865316937386!2d73.16981!3d33.72412!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38dfbf5b7c6b0001%3A0x5b5b5b5b5b5b5b5b!2sIslamabad%2C%20Pakistan!5e0!3m2!1sen!2sus!4v1234567890"
                                ></iframe>
                            </div>
                        </div>

                        {/* Contact Form */}
                        <div className="bg-white p-8 rounded-lg shadow-lg">
                            {submitted && (
                                <div className="mb-6 p-4 bg-emerald-100 text-emerald-800 rounded-lg">
                                    Thank you for your message! We will get back to you soon.
                                </div>
                            )}
                            <form onSubmit={handleSubmit} className="space-y-6">
                                <div>
                                    <label className="block text-gray-700 font-semibold mb-2">Name</label>
                                    <input
                                        type="text"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        required
                                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-emerald-500"
                                        placeholder="Your Name"
                                    />
                                </div>
                                <div>
                                    <label className="block text-gray-700 font-semibold mb-2">Email</label>
                                    <input
                                        type="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        required
                                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-emerald-500"
                                        placeholder="your@email.com"
                                    />
                                </div>
                                <div>
                                    <label className="block text-gray-700 font-semibold mb-2">Phone</label>
                                    <input
                                        type="tel"
                                        name="phone"
                                        value={formData.phone}
                                        onChange={handleChange}
                                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-emerald-500"
                                        placeholder="+92 300 1234567"
                                    />
                                </div>
                                <div>
                                    <label className="block text-gray-700 font-semibold mb-2">Subject</label>
                                    <input
                                        type="text"
                                        name="subject"
                                        value={formData.subject}
                                        onChange={handleChange}
                                        required
                                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-emerald-500"
                                        placeholder="Message Subject"
                                    />
                                </div>
                                <div>
                                    <label className="block text-gray-700 font-semibold mb-2">Message</label>
                                    <textarea
                                        name="message"
                                        value={formData.message}
                                        onChange={handleChange}
                                        required
                                        rows="5"
                                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-emerald-500"
                                        placeholder="Your message..."
                                    ></textarea>
                                </div>
                                <button
                                    type="submit"
                                    disabled={loading}
                                    className="w-full bg-emerald-500 text-white font-bold py-3 rounded-lg hover:bg-emerald-600 transition disabled:opacity-50"
                                >
                                    {loading ? 'Sending...' : 'Send Message'}
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Contact;
